export default __webpack_public_path__ + "static/media/en_vrai_c@etait_bien_3.cbd38338.png";